import React, { useEffect, useState, useCallback } from "react";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './reportNavbar.css'

export default function OffCanvasNavbar(props) {
  return (
    <Navbar key={'xl'} expand={'xl'} className="bg-body-tertiary mb-3 report-navbar">
    <Container fluid>
      <Navbar.Brand></Navbar.Brand>
      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${'xl'}`} />
      <Navbar.Offcanvas
        id={`offcanvasNavbar-expand-${'xl'}`}
        aria-labelledby={`offcanvasNavbarLabel-expand-${'xl'}`}
        placement="bottom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${'xl'}`} style={{fontWeight:900}}>
            Options
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="justify-content-end flex-grow-1 pe-3">
            {props.localtoggle && <div style={{padding: 10}}>{props.localtoggle}</div>}
            {props.secondtoggle && <div style={{padding: 10}}>{props.secondtoggle}</div>}
            {props.selectfirst && <div style={{padding: 10}}>{props.selectfirst}</div>}
            {props.selectsecond && <div style={{padding: 10}}>{props.selectsecond}</div>}
            {props.buttonfirst && <div style={{padding: 10}}>{props.buttonfirst}</div>}
            {props.buttonsecond && <div style={{padding: 10}}>{props.buttonsecond}</div>}
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Container>
  </Navbar>
  );
}